import { z } from 'zod';

export const documentSchema = z.object({
  documentId: z.string(),
  fileName: z.string(),
  fileUrl: z.string().optional(),
});

export type DocumentFormValues = z.infer<typeof documentSchema>;
